
import React from 'react'
import { Input } from 'antd'
import SetColor from '../setColor/index.jsx'
import Slider from '../slider/index.jsx'

export default function Card3(props) {
  return <React.Fragment>

    <div className='suspensionSide_item'>
      <span className='item_title'>二维码描述</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <span className='item_tips'>非微信流量显示的文本</span>
          <Input showCount maxLength={20} value={props.ifon.cardStyle.card3.describe1} onChange={(e) => {
            props.ifon.cardStyle.card3.describe1 = e.target.value
            props.mySetIfon(props.ifon)
          }}></Input>
        </div>
        <div className='item'>
          <span className='item_tips'>微信流量显示的文本</span>
          <Input showCount maxLength={20} value={props.ifon.cardStyle.card3.describe2} onChange={(e) => {
            props.ifon.cardStyle.card3.describe2 = e.target.value
            props.mySetIfon(props.ifon)
          }}></Input>
        </div>

      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>描述颜色</span>
      <div className='item_mainTransverse'>
        <ul className='item_ul'>
          <li className='ul_li'>
            <span className='li_span'>文字</span>
            <SetColor color={props.ifon.cardStyle.card3.color} setColor={(obj) => {
              props.ifon.cardStyle.card3.color = obj.hex
              props.mySetIfon(props.ifon)
            }}></SetColor>
          </li>
        </ul>
      </div>
    </div>

    <div className='suspensionSide_item'>
      <span className='item_title'>描述字号</span>
      <div className='item_mainColumn'>
        <div className='item'>
          <Slider maxValue={30} defaultValue={props.ifon.cardStyle.card3.fontSize} change={(value) => {
            props.ifon.cardStyle.card3.fontSize = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>
  </React.Fragment>
}
